import errors from "../errors";
import "babel-polyfill";
import "whatwg-fetch";
import { redirectToLogin } from "./redirectActions";
import { getAnyAccessToken } from "./authHelper";

// eslint-disable-next-line
const { showLoggedOutMessage, show5xxResponseErrorMessage, log4xxResponseError, showRequestPreflightErrorMessage } =
  errors.actions;

const request = ({ url, headers, body, method = "get" }) => {
  let _headers = headers
    ? headers
    : {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

  const accessToken = getAnyAccessToken();

  if (accessToken) {
    _headers.Authorization = `Bearer ${accessToken}`;
  }
  return fetch(url, {
    // eslint-disable-line
    method: method,
    headers: _headers,
    body: body,
  });
};

const CORS_PREFLIGHT_ERROR = "CORS_PREFLIGHT_ERROR";

export const runGenerator = (g, timeout) => {
  let it = g();
  let ret;

  // asynchronously iterate over generator
  (function iterate(val) {
    ret = it.next(val);
    setTimeout(function () {
      if (!ret.done) {
        // poor man's "is it a promise?" test, but nothing else is available
        if (ret.value && typeof ret.value.then === "function") {
          // wait on the promise
          ret.value.then(iterate).catch(function (_error) {
            // We caught an exception while running native fetch()
            // The most likely scenario here is that the service
            // returns something unacceptable for the preflight
            // OPTIONS request (eg. it is down for maitenance and
            // the proxy returns status code 502 or something)
            // or the server is not responding at all

            // Note that the access gateway returns 200 for the
            // preflight OPTIONS request even when the token has expired
            // and then returns 401 on the subsequent (non preflight) request
            it.next(CORS_PREFLIGHT_ERROR);
          });
        } else {
          // immediate value: just send right back in
          // avoid synchronous recursion
          setTimeout(function () {
            iterate(ret.value);
          }, 0);
        }
      }
    }, timeout || 0);
  })();
};

// setup default generic handling of backend responses
export const defaultRequestGenerator = ({ startAction, successAction, dispatch, requestObj }) => {
  return function* generator() {
    if (startAction) dispatch(startAction());
    let results = yield request(requestObj);

    switch (results.status) {
      case 401:
        // the access token is not valid
        return dispatch(redirectToLogin());
      default:
        if ([200, 201].includes(results.status)) {
          const json = yield results.json();
          json["url"] = results.url;
          return dispatch(successAction(json));
        }
    }
  };
};
